import { render, staticRenderFns } from "./BattlesGameElement.vue?vue&type=template&id=94a917c8&scoped=true"
import script from "./BattlesGameElement.vue?vue&type=script&lang=js"
export * from "./BattlesGameElement.vue?vue&type=script&lang=js"
import style0 from "./BattlesGameElement.vue?vue&type=style&index=0&id=94a917c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a917c8",
  null
  
)

export default component.exports